import { axiosInstance } from "../../../config/interceptor";
import { REWARD_DASHBOARD } from "../../../utils/constants/apis.urls";

export const getRewardHistory = (user_id: number) => {
  return axiosInstance.get(REWARD_DASHBOARD.REWARD_HISTORY.replace(':user_id', user_id.toString()));
}

export const fetchBalanceDetail = (user_id: number) => {
  return axiosInstance.get(REWARD_DASHBOARD.FETCH_BALANCE_DETAILS.replace(':user_id', user_id.toString()))
}